<template>
    <small :for="field.id" v-bind="attributes" v-show="field.instructions">
        {{ field.instructions }}
    </small>
</template>

<script>
    import Helper from "./Helper";

    export default {
        props: {
            field: {
                type: Object,
                required: true,
            }
        },
        data() {
            return {
                attributes: {},
            }
        },
        mounted() {
            this.attributes = Helper.setupAttributes(this.attributes, this.field.instructionAttributes);
        }
    }
</script>